import { clientApiCall } from "./apiCallWrapper";

/**
 * Клиентский (браузерный) API DaData (определение города, подсказки адреса).
 * Напрямую в nestFarkopDatabase (/database/dadata/*).
 */
export default (_axios: any, config: any) => ({
  /**
   * Где вызывается: во всех header-компонентах лейаутов —
   * components/layouts/main/header, mainNew/header, landings/header,
   * baltex/header, cart/header. Автоопределение города по IP при заходе на
   * сайт — срабатывает практически на каждой странице.
   */
  detectCity() {
    return clientApiCall(
      `${config.SERVICE_DATABASE_API_URL}/dadata/detect-city/`,
      { api: "dadata.detectCity", skipForRobots: true },
    );
  },
  /**
   * Где вызывается: components/popups/locationNew — попап выбора города,
   * автокомплит по названию. Порт старого `Api.location.getCityList`.
   * Возвращает ответ DaData `{ suggestions: [{ value, data }] }`.
   */
  getCityList(q: string) {
    return clientApiCall(
      `${config.SERVICE_DATABASE_API_URL}/dadata/city-list/`,
      { api: "dadata.getCityList", params: { q } },
    );
  },
});
